import { Config } from "./Config";

const env: Config = {
    UNSPLASH_API_KEY: "luN7klm32tvVZ1aOyBbXrRybV9z4mh7igjolB43VHG8",
};

export default env;
